import React from 'react'

const Prestadores = () => {
   return (
      <>
         <div className="section animated fadeIn">
            {/* TÍTULO DE LA SECCIÓN */}
            <div className="row mb-title center mb-4" id="seccionPretadores">
               <div className="col s12 m12 l12 x12">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     PRESTADORES
                  </h4>
               </div>
            </div>
            {/* TARJETA CONTENEDORA */}
            <div className="row justify-content-center">
               <div className="col s12 m12 l12">
                  <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '30px' }}>
                     <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', marginBottom: '0', paddingBottom: '0' }}>
                        <div className="col s8 m9 l10">
                           <h6 className="grey-text text-darken-3" style={{ fontWeight: '600', margin: '0', fontSize: '1.05rem' }}>
                              Cartilla de Prestadores
                           </h6>
                        </div>
                        <div className="col s4 m3 l2 center-align">
                           <a 
                              className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                              rel="noopener noreferrer" 
                              href={`${process.env.REACT_APP_API_URL}/web/download/PrestadoresLatitudSur.pdf`}
                              target="_blank"
                              style={{ borderRadius: '4px', textTransform: 'none', width: '100%' }}
                           >
                              Descargar
                              <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '5px' }}>cloud_download</i>
                           </a>
                        </div>
                     </div>
                     {/* ANCLAJE DE CONTRATOS */}
                     <div id="seccionContratos" />
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Prestadores